import { BarProgressCard } from "./BarProgressCard";

export default BarProgressCard;